import React, { Fragment } from 'react';
import SectionHeader from '../common/SectionHeader';
import SearchForm from '../searchForm';
import Pagination from '../common/Pagination';
import ProjectSearchHeader from './ProjectSearchHeader';
import ProjectsTable from './ProjectsTable';
import ProjectService from '../../services/ProjectService';
import CheckboxList from '../form/CheckboxList';
import Datepicker from '../form/Datepicker';
import StaticData from '../../services/StaticData';

const pageLimit = 10;
const pageRange = 5;

const DefaultSearchFields = () => (
  <Fragment>
    <div className="box">
      <cite>By Type</cite>
      <CheckboxList
        name="projectType"
        options={StaticData.ProjectTypes} />
    </div>
    <div className="box">
      <cite>By complexity</cite>
      <CheckboxList
        name="complexity"
        options={StaticData.Complexity} />
    </div>
    <div className="box">
      <cite>By Date Range</cite>
      <div className="day-picker date-from">
        <span>From</span>
        <Datepicker name="startDate" />
      </div>
      <div className="day-picker date-to">
        <span>To</span>
        <Datepicker name="endDate" />
      </div>
    </div>
  </Fragment>
);

class ProjectList extends React.Component {

  constructor(props) {
    super(props);

    this.onSearch = this.onSearch.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onPageIndexChanged = this.onPageIndexChanged.bind(this);

    this.state = {
      filter: {},
      currentPage: 1,
      totalCount: 0,
      projects: []
    };
  }

  loadData() {

    const reqParams = {
      ...this.state.filter,
      page: { number: this.state.currentPage, size: pageLimit }
    };

    ProjectService
      .get(reqParams)
      .then(result => {
        this.setState({
          projects: result.items,
          totalCount: result.totalCount
        });
      });
  }

  componentDidMount() {
    this.onSearch(this.props.initialFilter);
    //this.loadData();
  }

  onSearch(values) {
    this.setState({ filter: values, currentPage: 1 }, this.loadData);
  }

  onClear() {
    this.setState({ filter: this.props.initialFilter, currentPage: 1 }, this.loadData);
  }

  onPageIndexChanged(page) {
    if (this.state.currentPage !== page) {
      this.setState({ currentPage: page }, this.loadData);
    }
  }

  render() {

    const SearchFieldsComponent = this.props.searchFieldsComponent;

    return (
      <React.Fragment>
        <SectionHeader title={this.props.title} />
        <SearchForm
          initialValues={this.props.initialFilter}
          searchHeader={ProjectSearchHeader}
          onSubmit={this.onSearch}
          onReset={this.onClear}>
          <SearchFieldsComponent />
        </SearchForm>
        <ProjectsTable
          projects={this.state.projects} />
        <Pagination
          currentPage={this.state.currentPage}
          pageSize={pageLimit}
          totalCount={this.state.totalCount}
          visibleRange={pageRange}
          onPageChanged={this.onPageIndexChanged}
        />
      </React.Fragment>
    );
  }
}

ProjectList.defaultProps = {
  searchFieldsComponent: DefaultSearchFields
}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectList.js